import { Component, OnInit, Input } from '@angular/core';
import { CmsData, CmsDataProject } from 'src/app/models/cmsdata';
import { DataService } from 'src/app/services/data.service';
import { UtilService } from 'src/app/services/util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'artists-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.scss']
})
export class SingleComponent implements OnInit {

  @Input()
  public projectId: string = "";

  public projects: CmsDataProject[];
  public project: CmsDataProject;

  public bgProject: string = "unset";
  public bgArtist: string = "unset";

  constructor(
    private dataService: DataService,
    private utilService: UtilService,
    private router: Router
  )
  {
    this.subscribe();
  }

  ngOnInit(): void {
    this.draw();
  }

  subscribe() {
    this.dataService.projects.subscribe((data) => {
      this.projects = data;
      this.draw();
    });
  }

  draw() {
    if (this.projectId) {
      this.project = this.projects.find(project => project.project_slug === this.projectId);
    }
    this.bgProject = this.project?.project_image ? `url('${this.project.project_image}')` : "unset";
    this.bgArtist = this.project?.artist_photo ? `url('${this.project.artist_photo}')` : "unset";
  }

  click($event: any, type: string) {
    if ($event) {
      $event.preventDefault();
    }
    if (this.project) {
      switch (type) {
        case "audio":
          window.open(this.project.artist_audio, "_blank", 'noopener,noreferrer');
        break;
        case "howto":
          this.utilService.modalCloseUrl.next(`/map/artist/${this.project.project_slug}`);
          this.router.navigate([ "/map/how-to-interact" ]);
          // @todo modalCloseUrl when navigating modal to modal?
        break;
        case "directions":
          window.open(this.project.directions_url, "_blank", 'noopener,noreferrer');
        break;
        case "instagram":
          window.open(this.project.artist_instagram, "_blank", 'noopener,noreferrer');
        break;
        default:
          console.error(`Unknown click type '${type}'`);
      }
    }
  }
  
}